import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";

import { fetchProcessorGroups, addProcessorGroup, filteredData, getProcessorGroups } from '../../../redux/actions/ProcessingGroupActions';

import { Panel, PanelBody } from "../../header/panel/panel"

import { fetchProcessorTerminalsForAssignment } from '../../../redux/actions/DropdownActions';
import TerminalProcessingGrouping from './TerminalProcessingGrouping';
import ProcessingGroupHistory from './ProcessingGroupHistory';



const AddEditProcessorGroup = (props) => {

    const [, setMerchantID] = useState('')

    useEffect(() => {
        props.fetchProcessorGroups(props.MERCHANTREDUCER.merchantID)
        props.filteredData()
        props.fetchProcessorTerminalsForAssignment(props.MERCHANTREDUCER.merchantID)
        setMerchantID(props.MERCHANTREDUCER.merchantID)

    }, [])



    return (

        <Panel>

            <PanelBody>
                {props.PROCESSORGROUPSREDUCER.processorGroups && props.PROCESSORGROUPSREDUCER.processorGroups.length ? props.PROCESSORGROUPSREDUCER.processorGroups.map((data) => {
                    return (
                        <>
                            <div className="row mb-0">
                                <div className="col-xl-6">
                                    <TerminalProcessingGrouping processingGroupID={data.processingGroupID} merchantID={props.MERCHANTREDUCER.merchantID}></TerminalProcessingGrouping>
                                </div>
                                <div className="col-xl-6">
                                    <ProcessingGroupHistory processingGroupID={data.processingGroupID}></ProcessingGroupHistory>
                                </div>
                            </div>


                        </>
                    )
                })
                    : null}

            </PanelBody>
        </Panel>

    )

}

function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    addProcessorGroup,
    fetchProcessorGroups,
    filteredData,
    getProcessorGroups,
    fetchProcessorTerminalsForAssignment
}



export default connect(mapStateToProps, mapDispatchToProps)(AddEditProcessorGroup);
